import { type } from "@/api/arktype";

export const AUTO_FIELD_COLUMNS = [
	"name",
	"cpf",
	"rg",
	"birth_date",
	"mother_name",
	"occupation",
	"marital_status",
	"address",
	"phone",
	"email",
	"age",
	"current_date",
] as const;

export const autoFieldColumn = type.enumerated(...AUTO_FIELD_COLUMNS);
